// Eén matrixrij (stelling) kopiëren naar een ander veld, meestal bij een andere
// organisatie (portfolio → project).
//
// Nodig omdat er vier kopieerpaden waren die elk een ander deel van de rij
// meenamen: de effect-route liet `posNeg` weg (een negatief geformuleerde
// stelling telde in het project omgekeerd mee), de abonneer-route `TitleRight`,
// en geen enkele route nam de meetstandaard-herkomst mee.
//
// Bewust NIET mee: doelgroepen (`TargetGroup`, `targetGroups*`) — dat zijn ID's
// van de bronorganisatie — en alles wat het brondocument zelf identificeert
// (`docid`, `Deleted`, oude `Timestamp`).
// AI-CONTEXT: See docs/pitfalls.md#database-string-enum-boolean-coercion

/**
 * @typedef {object} CopyTarget
 * @property {string} fieldId - ID van het nieuwe QuestionnaireField
 * @property {string} question - Vraagtitel die op de rij komt
 * @property {string} client - CompagnyID van de ontvangende organisatie
 * @property {*} timestamp - Aanmaakmoment
 * @property {string} id - Nieuw ID voor de rij
 */

/**
 * @param {object} source - De MatrixQuestionRows-data van de bron
 * @param {CopyTarget} target
 * @returns {object} Payload voor een nieuw MatrixQuestionRows-document
 */
const buildCopiedMatrixRow = (source, { fieldId, question, client, timestamp, id }) => ({
    Title: source.Title || '',
    TitleRight: source.TitleRight || '',
    Question: question,
    Field: fieldId,
    Compagny: client,
    CompagnyID: client,
    Timestamp: timestamp,
    Position: source.Position,
    ID: id,
    // Ongewijzigd doorgeven: alleen de tekst 'negative' spiegelt een score, en
    // dat oordeel hoort bij de lezer, niet bij de kopie.
    posNeg: source.posNeg || '',
    Color: source.Color || '',
    MSIId: source.MSIId || '',
    Standaard: source.Standaard || '',
    StandaardVersion: source.StandaardVersion || '',
    EffectUid: source.EffectUid || '',
    StellingNummer: Number.isFinite(source.StellingNummer) ? source.StellingNummer : null,
})

export default buildCopiedMatrixRow
